import { render } from "./PageHelp.vue?vue&type=template&id=1bfeb701"
import script from "./PageHelp.vue?vue&type=script&lang=js"
export * from "./PageHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__